import React, { useRef } from "react";

import { useNavigate } from "react-router-dom";

// import "../App.css";
import "../../index.css";
import "tachyons";
import "./home.css"
import AnimatedServices from "./AnimatedServices";

function Home() {
  const navigate = useNavigate();


  return (
    <div className="App bg-black  ">
      <div className="section-hero pt4  ">
        <h2 className="hero__heading ml4 mr4 ">
          Welcome to
          <span> Terraweb</span>
        </h2>
        <p className="hero__paragraph">
          "Building <span>Bonds</span>
          Beyond <span>Boundaries"</span>
        </p>
        <div className="hero__buttons">
          <button className="btn btn-orange br-pill">
            <label onClick={() => navigate("/login")} className="link-orange">
              Sign In
            </label>
          </button>
          <button className="btn btn-white br-pill">
            <label onClick={() => navigate("/register")} className="link-white">
              Sign Up
            </label>
          </button>
        </div>
      </div>

      <div className="about-section container">
        <img
          src="/img/LOGO-FAVCON.png"
          alt="terraweb logo"
          className="about-section__image"
        />
        <div className="about-section__text white">
          <h3 className="about-section__text--heading">Terrawebgroup</h3>
          <p className="about-section__text--paragraph white">
            We are a local youth group driven by a vision and ambition to build
            bonds through data processing, analyzing and communication using
            technology in order to enhance, empower and connect.
          </p>
        </div>
      </div>

      {/* <div className="services-section">
         <div className="container services">
          <div className="servicees__service">
            <h3 className="services__service--title">Services</h3>
            <p className="services__service--text">
              <ul className="ml-20">
                <li>Data processing</li>
                <li>Cloud data management</li>
                <li>Information communication</li>
                <li>Agricultural e-learning</li>
              </ul>
            </p>
          </div>
          <div className="servicees__service">
            <h3 className="services__service--title">Vision</h3>
            <p className="services__service--text">
              To nurture a winning network by building bonds for long-term value,
              in the value chain.
            </p>
          </div>
          <div className="servicees__service">
            <h3 className="services__service--title">Mission</h3>
            <p className="services__service--text">
              To enhance, empower and connect through technology to create worth
              and make a distinction.
            </p>
          </div>
          <div className="servicees__service">
            <h3 className="services__service--title">AIMS</h3>
            <p className="services__service--text">
              To build bonds through technology in order to create worth in the
              Value chain network.
            </p>
          </div>
        </div>
      </div> */}

      {/* new AI2 */}
  <AnimatedServices/>


    </div>
  );
}

export default Home;
